import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface RawResult {
  createUser: boolean;
}

export type Args = {
  name: string;
  email: string;
  groupId: string;
  isGroupAdmin: boolean;
};

export const createUser = async <V>(
  apollo: DollarApollo<V>,
  args: Args
): Promise<FetchResult<RawResult>> => {
  const { name, email, groupId, isGroupAdmin } = args;
  const result = apollo.mutate<RawResult>({
    mutation: Mutation,
    variables: {
      name,
      email,
      groupId,
      isGroupAdmin
    }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
